import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    if (!historyItems || !historyItems.length) {
        return
    }

    return (
        <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
            <div class="ns-w-100 ns-mt-sm-auto">
                {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                    Recently Searched
                </div> */}
                <div>
                    {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                        <HistoryElement key={item} query={{ query: item }}>
                            <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4">
                                {item}
                            </div>
                        </HistoryElement>
                    ))}
                </div>
            </div>
        </div>
    )
}
